<template>
  <v-app style="background-color: #f3f6f9">
    <v-main>
      <nav-bar></nav-bar>
      <ReportsList />
    </v-main>
  </v-app>
</template>
<script>
import NavBar from '@/components/widgets/navBar.vue'
import ReportsList from '@/components/seller/ReportsList.vue'
import Auth from '@/services/auth.service.js'

export default {
  components: {
    NavBar,
    ReportsList
  },
  mounted() {
    document.title = 'Reports | ISRASIM'

    let auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: "login" })
    }
  },
}
</script>
  